var _style, _style2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: 131,
    height: 59,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  text {\n    text-anchor: middle; font-size: 16px; opacity: 0;\n  }\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "65.5px 29.5px",
      transform: "scale(1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.5,29.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-31.095px -1.26973px",
      animation: "1s linear -0.6s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10-1.36L8.10 0L1.44 0L1.44-11.20L2.96-11.20L2.96-1.36L8.10-1.36",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-22.905px 0.170272px",
      animation: "1s linear -0.54s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.63-4.16L15.63-4.16L15.63-4.16Q15.63-4.78 15.43-5.34L15.43-5.34L15.43-5.34Q15.23-5.90 14.87-6.32L14.87-6.32L14.87-6.32Q14.51-6.74 14.02-6.98L14.02-6.98L14.02-6.98Q13.54-7.23 12.96-7.23L12.96-7.23L12.96-7.23Q11.70-7.23 10.99-6.40L10.99-6.40L10.99-6.40Q10.29-5.57 10.29-4.19L10.29-4.19L10.29-4.19Q10.29-3.57 10.49-3L10.49-3L10.49-3Q10.69-2.43 11.05-2.01L11.05-2.01L11.05-2.01Q11.41-1.58 11.90-1.34L11.90-1.34L11.90-1.34Q12.38-1.09 12.96-1.09L12.96-1.09L12.96-1.09Q13.58-1.09 14.08-1.31L14.08-1.31L14.08-1.31Q14.58-1.54 14.92-1.94L14.92-1.94L14.92-1.94Q15.26-2.35 15.45-2.91L15.45-2.91L15.45-2.91Q15.63-3.47 15.63-4.16zM8.82-4.16L8.82-4.16L8.82-4.16Q8.82-5.17 9.14-5.98L9.14-5.98L9.14-5.98Q9.46-6.78 10.01-7.34L10.01-7.34L10.01-7.34Q10.56-7.90 11.32-8.21L11.32-8.21L11.32-8.21Q12.08-8.51 12.96-8.51L12.96-8.51L12.96-8.51Q13.82-8.51 14.58-8.21L14.58-8.21L14.58-8.21Q15.34-7.90 15.90-7.34L15.90-7.34L15.90-7.34Q16.46-6.78 16.78-5.98L16.78-5.98L16.78-5.98Q17.10-5.18 17.10-4.19L17.10-4.19L17.10-4.19Q17.10-3.20 16.79-2.39L16.79-2.39L16.79-2.39Q16.48-1.58 15.92-1.01L15.92-1.01L15.92-1.01Q15.36-0.43 14.60-0.12L14.60-0.12L14.60-0.12Q13.84 0.19 12.96 0.19L12.96 0.19L12.96 0.19Q12.06 0.19 11.30-0.13L11.30-0.13L11.30-0.13Q10.54-0.45 9.99-1.02L9.99-1.02L9.99-1.02Q9.44-1.60 9.13-2.40L9.13-2.40L9.13-2.40Q8.82-3.20 8.82-4.16",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-13.145px 0.170272px",
      animation: "1s linear -0.48s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.46-4.11L18.46-4.11L18.46-4.11Q18.46-5.04 18.75-5.85L18.75-5.85L18.75-5.85Q19.04-6.66 19.56-7.25L19.56-7.25L19.56-7.25Q20.08-7.84 20.81-8.18L20.81-8.18L20.81-8.18Q21.54-8.51 22.40-8.51L22.40-8.51L22.40-8.51Q23.12-8.51 23.70-8.26L23.70-8.26L23.70-8.26Q24.29-8.02 24.72-7.65L24.72-7.65L24.72-8.32L26.03-8.32L26.03-2.02L26.03-2.02Q26.03-1.41 26.33-1.22L26.33-1.22L26.33-1.22Q26.62-1.04 26.98-1.04L26.98-1.04L26.67 0.08L26.67 0.08Q25.14 0.08 24.82-1.17L24.82-1.17L24.82-1.17Q24.62-0.91 24.38-0.66L24.38-0.66L24.38-0.66Q24.13-0.42 23.81-0.22L23.81-0.22L23.81-0.22Q23.49-0.03 23.09 0.08L23.09 0.08L23.09 0.08Q22.69 0.19 22.21 0.19L22.21 0.19L22.21 0.19Q21.42 0.19 20.74-0.11L20.74-0.11L20.74-0.11Q20.06-0.42 19.56-0.98L19.56-0.98L19.56-0.98Q19.06-1.54 18.76-2.33L18.76-2.33L18.76-2.33Q18.46-3.12 18.46-4.11zM22.53-1.09L22.53-1.09L22.53-1.09Q23.14-1.09 23.68-1.38L23.68-1.38L23.68-1.38Q24.22-1.66 24.59-2.13L24.59-2.13L24.59-6.59L24.59-6.59Q24.16-6.90 23.64-7.08L23.64-7.08L23.64-7.08Q23.12-7.26 22.54-7.26L22.54-7.26L22.54-7.26Q21.97-7.26 21.49-7.04L21.49-7.04L21.49-7.04Q21.01-6.82 20.66-6.41L20.66-6.41L20.66-6.41Q20.32-6 20.13-5.42L20.13-5.42L20.13-5.42Q19.94-4.85 19.94-4.16L19.94-4.16L19.94-4.16Q19.94-3.49 20.13-2.92L20.13-2.92L20.13-2.92Q20.32-2.35 20.67-1.94L20.67-1.94L20.67-1.94Q21.02-1.54 21.50-1.31L21.50-1.31L21.50-1.31Q21.97-1.09 22.53-1.09",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "-3.46499px -1.49473px",
      animation: "1s linear -0.42s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.89 0.19L31.89 0.19L31.89 0.19Q31.12 0.19 30.44-0.11L30.44-0.11L30.44-0.11Q29.76-0.42 29.26-0.98L29.26-0.98L29.26-0.98Q28.75-1.54 28.46-2.33L28.46-2.33L28.46-2.33Q28.18-3.12 28.18-4.11L28.18-4.11L28.18-4.11Q28.18-5.06 28.47-5.86L28.47-5.86L28.47-5.86Q28.77-6.67 29.27-7.26L29.27-7.26L29.27-7.26Q29.78-7.84 30.45-8.18L30.45-8.18L30.45-8.18Q31.12-8.51 31.87-8.51L31.87-8.51L31.87-8.51Q32.70-8.51 33.30-8.18L33.30-8.18L33.30-8.18Q33.90-7.84 34.24-7.49L34.24-7.49L34.24-11.84L35.68-11.84L35.68-2.02L35.68-2.02Q35.68-1.41 35.98-1.22L35.98-1.22L35.98-1.22Q36.27-1.04 36.62-1.04L36.62-1.04L36.32 0.08L36.32 0.08Q34.80 0.08 34.46-1.14L34.46-1.14L34.46-1.14Q34.10-0.62 33.47-0.22L33.47-0.22L33.47-0.22Q32.85 0.19 31.89 0.19zM32.21-1.09L32.21-1.09L32.21-1.09Q32.80-1.09 33.34-1.37L33.34-1.37L33.34-1.37Q33.87-1.65 34.24-2.10L34.24-2.10L34.24-6.22L34.24-6.22Q33.94-6.61 33.40-6.94L33.40-6.94L33.40-6.94Q32.86-7.26 32.19-7.26L32.19-7.26L32.19-7.26Q31.62-7.26 31.14-7.02L31.14-7.02L31.14-7.02Q30.67-6.78 30.34-6.37L30.34-6.37L30.34-6.37Q30-5.95 29.82-5.38L29.82-5.38L29.82-5.38Q29.65-4.82 29.65-4.16L29.65-4.16L29.65-4.16Q29.65-3.49 29.84-2.93L29.84-2.93L29.84-2.93Q30.03-2.37 30.38-1.96L30.38-1.96L30.38-1.96Q30.72-1.55 31.19-1.32L31.19-1.32L31.19-1.32Q31.66-1.09 32.21-1.09",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "3.39501px 0.170272px",
      animation: "1s linear -0.36s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.98-8.32L39.98 0L38.54 0L38.54-8.32L39.98-8.32",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "3.40001px -6.41973px",
      animation: "1s linear -0.3s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.26-9.74L39.26-9.74L39.26-9.74Q38.85-9.74 38.55-10.04L38.55-10.04L38.55-10.04Q38.26-10.34 38.26-10.75L38.26-10.75L38.26-10.75Q38.26-11.22 38.53-11.49L38.53-11.49L38.53-11.49Q38.80-11.76 39.26-11.76L39.26-11.76L39.26-11.76Q39.68-11.76 39.98-11.46L39.98-11.46L39.98-11.46Q40.27-11.17 40.27-10.75L40.27-10.75L40.27-10.75Q40.27-10.29 40.00-10.02L40.00-10.02L40.00-10.02Q39.73-9.74 39.26-9.74",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "10.175px 0.0752721px",
      animation: "1s linear -0.24s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.94-8.32L43.94-6.93L43.94-6.93Q44.38-7.60 45.08-8.06L45.08-8.06L45.08-8.06Q45.78-8.51 46.74-8.51L46.74-8.51L46.74-8.51Q48.14-8.51 48.84-7.66L48.84-7.66L48.84-7.66Q49.54-6.82 49.54-5.42L49.54-5.42L49.54 0L48.10 0L48.10-5.26L48.10-5.26Q48.10-6.18 47.68-6.71L47.68-6.71L47.68-6.71Q47.26-7.25 46.50-7.25L46.50-7.25L46.50-7.25Q46.13-7.25 45.78-7.11L45.78-7.11L45.78-7.11Q45.42-6.98 45.10-6.74L45.10-6.74L45.10-6.74Q44.77-6.50 44.49-6.18L44.49-6.18L44.49-6.18Q44.21-5.86 43.98-5.50L43.98-5.50L43.98 0L42.54 0L42.54-8.32L43.94-8.32",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "19.315px 1.93027px",
      animation: "1s linear -0.18s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.31-8.51L55.31-8.51L55.31-8.51Q56.03-8.51 56.60-8.27L56.60-8.27L56.60-8.27Q57.17-8.03 57.58-7.68L57.58-7.68L57.58-8.32L58.90-8.32L58.90-0.19L58.90-0.19Q58.90 0.85 58.62 1.58L58.62 1.58L58.62 1.58Q58.35 2.32 57.85 2.79L57.85 2.79L57.85 2.79Q57.34 3.26 56.64 3.49L56.64 3.49L56.64 3.49Q55.94 3.71 55.07 3.71L55.07 3.71L55.07 3.71Q54.32 3.71 53.63 3.54L53.63 3.54L53.63 3.54Q52.94 3.36 52.40 3.01L52.40 3.01L52.93 1.76L52.93 1.76Q53.31 2.06 53.82 2.26L53.82 2.26L53.82 2.26Q54.34 2.46 55.07 2.46L55.07 2.46L55.07 2.46Q56.21 2.46 56.86 1.87L56.86 1.87L56.86 1.87Q57.50 1.28 57.50-0.05L57.50-0.05L57.50-1.07L57.50-1.07Q57.18-0.69 56.58-0.34L56.58-0.34L56.58-0.34Q55.98 0 55.15 0L55.15 0L55.15 0Q54.45 0 53.78-0.28L53.78-0.28L53.78-0.28Q53.10-0.56 52.59-1.10L52.59-1.10L52.59-1.10Q52.08-1.63 51.77-2.41L51.77-2.41L51.77-2.41Q51.46-3.18 51.46-4.19L51.46-4.19L51.46-4.19Q51.46-5.12 51.76-5.91L51.76-5.91L51.76-5.91Q52.06-6.70 52.58-7.28L52.58-7.28L52.58-7.28Q53.10-7.86 53.81-8.18L53.81-8.18L53.81-8.18Q54.51-8.51 55.31-8.51zM55.47-1.28L55.47-1.28L55.47-1.28Q56.11-1.28 56.62-1.57L56.62-1.57L56.62-1.57Q57.14-1.86 57.46-2.24L57.46-2.24L57.46-6.59L57.46-6.59Q57.09-6.85 56.61-7.06L56.61-7.06L56.61-7.06Q56.13-7.26 55.46-7.26L55.46-7.26L55.46-7.26Q54.96-7.26 54.50-7.06L54.50-7.06L54.50-7.06Q54.05-6.86 53.70-6.48L53.70-6.48L53.70-6.48Q53.34-6.10 53.14-5.54L53.14-5.54L53.14-5.54Q52.93-4.99 52.93-4.27L52.93-4.27L52.93-4.27Q52.93-3.58 53.14-3.03L53.14-3.03L53.14-3.03Q53.34-2.48 53.70-2.09L53.70-2.09L53.70-2.09Q54.05-1.70 54.50-1.49L54.50-1.49L54.50-1.49Q54.96-1.28 55.47-1.28",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "26.63px 3.45027px",
      animation: "1s linear -0.12s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.42-0.88L61.42-0.88L61.42-0.88Q61.42-1.38 61.70-1.66L61.70-1.66L61.70-1.66Q61.98-1.95 62.50-1.95L62.50-1.95L62.50-1.95Q62.91-1.95 63.24-1.63L63.24-1.63L63.24-1.63Q63.57-1.31 63.57-0.88L63.57-0.88L63.57-0.88Q63.57-0.40 63.26-0.10L63.26-0.10L63.26-0.10Q62.96 0.19 62.50 0.19L62.50 0.19L62.50 0.19Q62.06 0.19 61.74-0.13L61.74-0.13L61.74-0.13Q61.42-0.45 61.42-0.88",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "31.43px 3.45027px",
      animation: "1s linear -0.06s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.22-0.88L66.22-0.88L66.22-0.88Q66.22-1.38 66.50-1.66L66.50-1.66L66.50-1.66Q66.78-1.95 67.30-1.95L67.30-1.95L67.30-1.95Q67.71-1.95 68.04-1.63L68.04-1.63L68.04-1.63Q68.37-1.31 68.37-0.88L68.37-0.88L68.37-0.88Q68.37-0.40 68.06-0.10L68.06-0.10L68.06-0.10Q67.76 0.19 67.30 0.19L67.30 0.19L67.30 0.19Q66.86 0.19 66.54-0.13L66.54-0.13L66.54-0.13Q66.22-0.45 66.22-0.88",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "36.23px 3.45027px",
      animation: "1s linear 0s infinite normal forwards running breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.02-0.88L71.02-0.88L71.02-0.88Q71.02-1.38 71.30-1.66L71.30-1.66L71.30-1.66Q71.58-1.95 72.10-1.95L72.10-1.95L72.10-1.95Q72.51-1.95 72.84-1.63L72.84-1.63L72.84-1.63Q73.17-1.31 73.17-0.88L73.17-0.88L73.17-0.88Q73.17-0.40 72.86-0.10L72.86-0.10L72.86-0.10Q72.56 0.19 72.10 0.19L72.10 0.19L72.10 0.19Q71.66 0.19 71.34-0.13L71.34-0.13L71.34-0.13Q71.02-0.45 71.02-0.88",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-35.864990234375,4.3302724109996475)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    id: "breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef",
    "data-anikit": ""
  }, "@keyframes breath-5b4f08d1-7d4a-4844-bde5-7b1fef39b7ef\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.9647,0.2413,-0.0705,0.7911);\n    transform: scale(0.9099999999999999);\n  }\n  51% {\n    animation-timing-function: cubic-bezier(0.9226,0.2631,-0.0308,0.7628);\n    transform: scale(1.02994);\n  }\n  100% {\n    transform: scale(0.9099999999999999);\n  }\n}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.322feef807572712defa06d35b44709c.svg";
export { ForwardRef as ReactComponent };